import { useEffect } from "react";

const usePageTitle = (title) => {
    useEffect(() => {
        const formattedTitle = title ? `${title} | River` : "River | CreativeCapital";

        // Update document title
        document.title = formattedTitle;

        // Update Open Graph title
        let ogTitleMeta = document.querySelector('meta[property="og:title"]');
        if (ogTitleMeta) {
            ogTitleMeta.content = formattedTitle;
        }

        // Update Twitter title
        let twitterTitleMeta = document.querySelector('meta[property="twitter:title"]');
        if (twitterTitleMeta) {
            twitterTitleMeta.content = formattedTitle;
        }
    }, [title]);
};

export default usePageTitle;
